
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Terminal } from '@/models/Terminal'
import MapFacilityInfo from '@/components/Map/FacilityInfo.vue'
import { MappableModel } from '@/interfaces/MappableModel'
import { Company } from '@/models/Company'
import { namespace } from 'vuex-class'
import Notification from '@/classes/Notification'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import Testable from '@/mixins/Testable'
import i18n from '@/i18n'

const Auth = namespace('auth')

@Component({
	components: {
		MapFacilityInfo,
		ConfirmationDialog
	}
})
export default class TerminalDetails extends Mixins(Testable) {
	@Prop({ required: true })
	terminal!: Terminal

	@Prop({ default: null })
	directionsTo!: MappableModel | null

	@Auth.Getter('currentCompany')
	userCompany!: Company

	confirmationDialogOpened = false
	isRemoving = false

	get address(): string {
		if (!this.terminal) {
			return ''
		}

		return (
			(this.terminal.address ? `${this.terminal.address}` : '') +
			(this.terminal.address && this.terminal.place ? ', ' : '') +
			(this.terminal.postalCode
				? `${this.terminal.postalCode} ${this.terminal.place}`
				: `${this.terminal.place}`) +
			(this.terminal.relation('country') ? ` (${this.terminal.relation('country').iso})` : '')
		)
	}

	get isEditable(): boolean {
		if (this.terminal.getOwnedBy()) {
			return this.userCompany.getApiId() === this.terminal.getOwnedBy().getApiId()
		}

		return false
	}

	async deleteTerminal() {
		if (this.terminal) {
			this.isRemoving = true
			await this.terminal.delete()
			this.confirmationDialogOpened = false
			await Notification.Success(i18n.t('terminals.deleted'))
			this.$emit('terminalRemoved', this.terminal)
			this.isRemoving = false
		}
	}
}
